import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    // If the URL has a hash (e.g., #contact), don't force scroll to top
    if (hash) return; 

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // Avoids smooth scrolling animations during navigation
    });
  }, [pathname, hash]);

  return null;
}